import React from "react";
import styles from "./AppMenuAction.module.css";
import { useLocation } from "react-router-dom";
import { useMenu } from "../../context/MenuContext";

export default function AppMenuAction({
  children,
  onClick,
  to = null,
  className = "",
  variant = "default"
}) {
  const location = useLocation();
  const { closeMenu } = useMenu() || {};

  const isActive = to && location.pathname === to;

  const handleClick = (e) => {
    onClick && onClick(e);
    closeMenu && closeMenu();
  };

  return (
    <button
      type="button"
      className={[
        styles.action,
        styles[variant],
        isActive ? styles.active : "",
        className
      ].join(" ")}
      onClick={handleClick}
    >
      {children}
    </button>
  );
}